export default __webpack_public_path__ + "static/media/Right line.f9c0b813.svg";